export default class Pill {

	static colors () {
		const result = []
		// 16 colors
		for (let i = 0; i < 16; i++) {
			result.push(i)
		}
		return result
	}

	static processResponse (data) {
		const result = []
		data.forEach(row => {
			result.push(row)
		})
		return result
	}
}



// WEBPACK FOOTER //
// ./src/classes/Pill.js